import { ApolloError } from '@apollo/client';

import { STATUS_CODES } from '@/constants/common';
import { useSnackbar } from '@/providers/SnackbarProvider';

export const getGraphQLErrorCode = (error: ApolloError): string | undefined =>
  error.graphQLErrors[0]?.extensions?.code as string | undefined;

interface HandleGraphQLErrorsOptions {
  error: ApolloError;
  customMessage?: string;
  onLockout?: (lockoutEnd: number) => void;
  statusMessages?: Record<string, string>;
}

export const useGraphQLErrorProcessor = () => {
  const { openSnackbar } = useSnackbar();

  return ({
    error,
    onLockout,
    customMessage,
    statusMessages = {}
  }: HandleGraphQLErrorsOptions) => {
    if (!error.graphQLErrors.length) return;

    const code = getGraphQLErrorCode(error);
    const firstError = error.graphQLErrors[0];
    const lockExpiresAt = firstError?.extensions?.lockExpiresAt;

    const errorMessage =
      statusMessages[code as string] || customMessage || firstError?.message;

    switch (code) {
      case STATUS_CODES.LIMIT_EXCEEDED:
        if (lockExpiresAt && onLockout)
          return onLockout(lockExpiresAt as number);
        openSnackbar(errorMessage, 'error');
        break;

      case STATUS_CODES.AUTHENTICATION_ERROR:
        throw new Error(errorMessage);

      default:
        openSnackbar(errorMessage, 'error');
        break;
    }
  };
};
